import React from "react";

export default function StatusBadge({ tone = "neutral", children }) {
  return <span className={`vp-status-badge is-${tone}`}>{children}</span>;
}
